var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ors-l-polyline" },
    [
      _c("l-polyline", {
        attrs: {
          "lat-lngs": _vm.latLngsCoordinates,
          opacity: _vm.routeOpacity,
          weight: _vm.backgroundWeight,
          color: _vm.backgroundColor
        }
      }),
      _vm._v(" "),
      _c("l-polyline", {
        ref: "foregroundPolyline",
        attrs: {
          options: _vm.options,
          "lat-lngs": _vm.latLngsCoordinates,
          weight: _vm.weight,
          opacity: _vm.routeOpacity,
          color: _vm.color
        },
        on: {
          follow: _vm.followPolyline,
          rightClicked: _vm.rightClicked,
          click: function($event) {
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            ) {
              return null
            }
            return _vm.click($event)
          },
          followMarkerClicked: function($event) {
            return _vm.click($event)
          },
          addstop: _vm.addStopViaPolylineDrag,
          add: _vm.openPopup
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f9f5318", { render: render, staticRenderFns: staticRenderFns })
  }
}